import { z } from 'zod';
import { MoneySchema } from './common.js';
import { PeriodStatusSchema } from './period.js';
// Wire enums for the 24-step close workflow. Mirror Prisma's PCloseStepPhase /
// PCloseStepStatus exactly. UI maps to lowercase at render time only.
export const PCloseStepPhaseSchema = z.enum([
    'PRE',
    'RECUR',
    'RECON',
    'REPORT',
    'APPROVAL',
    'LOCK',
]);
export const PCloseStepStatusSchema = z.enum(['PENDING', 'IN_PROGRESS', 'DONE', 'BLOCKED', 'NA']);
// Decimal `amount` arrives as either a 0-or-positive string (MoneySchema) or
// — after Prisma serialization — as a number. Coerce to keep the wire flexible.
export const PeriodCloseStepSchema = z.object({
    id: z.uuid(),
    companyId: z.uuid(),
    period: z.string().regex(/^\d{6}$/),
    stepNo: z.number().int().min(1).max(99),
    phase: PCloseStepPhaseSchema,
    name: z.string(),
    critical: z.boolean(),
    estMin: z.number().int().nonnegative(),
    refCount: z.number().int().nonnegative(),
    amount: z.union([MoneySchema, z.coerce.number()]),
    linkRoute: z.string().nullable(),
    status: PCloseStepStatusSchema,
    completedAt: z.coerce.date().nullable(),
    completedBy: z.string().nullable(),
    notes: z.string().nullable(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
export const PeriodCloseSummarySchema = z.object({
    total: z.number().int(),
    done: z.number().int(),
    inProgress: z.number().int(),
    blocked: z.number().int(),
    // criticalOpen = count of `critical && status NOT IN (DONE, NA)`. The
    // close-period endpoint refuses to transition Period.status -> CLOSED
    // while this is > 0.
    criticalOpen: z.number().int(),
    pct: z.number().int().min(0).max(100),
});
export const PeriodCloseChecklistSchema = z.object({
    period: z.string().regex(/^\d{6}$/),
    periodStatus: PeriodStatusSchema,
    summary: PeriodCloseSummarySchema,
    steps: z.array(PeriodCloseStepSchema),
});
export const UpdatePeriodCloseStepSchema = z.object({
    status: PCloseStepStatusSchema.optional(),
    notes: z.string().nullable().optional(),
});
//# sourceMappingURL=period-close.js.map